import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

const BASE_PATH = `${config.apis.api.url}/suarte-plus`;

function buildUrl(path = '') {
  const normalized = path ? `/${path.replace(/^[/]+/, '')}` : '';
  return `${BASE_PATH}${normalized}`;
}

async function getConfig() {
  return fetchWrapper.get(buildUrl('config'), {
    injectToken: true,
  });
}

async function calculateVat({ amount, payment_method_id, buyer_country, force_non_business_purchase } = {}) {
  const params = new URLSearchParams();
  if (typeof amount === 'number' && Number.isFinite(amount)) {
    params.set('amount', amount);
  }
  if (payment_method_id) {
    params.set('payment_method_id', payment_method_id);
  }
  if (buyer_country) {
    params.set('buyer_country', buyer_country);
  }
  if (force_non_business_purchase === true) {
    params.set('force_non_business_purchase', 'true');
  }
  const query = params.toString() ? `?${params.toString()}` : '';
  return fetchWrapper.get(buildUrl(`vat${query}`), {
    injectToken: true,
  });
}

async function subscribe({
  plan,
  payment_method_id,
  trialDays,
  metadata,
  buyer_country,
  buyerCountry,
  force_non_business_purchase,
} = {}) {
  return fetchWrapper.post(buildUrl('payment/subscribe'), {
    injectToken: true,
    body: {
      plan,
      payment_method_id,
      trialDays,
      metadata,
      buyer_country: buyer_country ?? buyerCountry ?? null,
      force_non_business_purchase: force_non_business_purchase === true,
    },
  });
}

async function confirmPayment({ plan, stripe_subscription_id, payment_method_id, metadata } = {}) {
  return fetchWrapper.post(buildUrl('payment/confirm'), {
    injectToken: true,
    body: {
      plan,
      stripe_subscription_id,
      payment_method_id,
      metadata,
    },
  });
}

async function cancelSubscription(subscriptionId) {
  if (!subscriptionId) {
    throw new Error('subscription id is required');
  }
  return fetchWrapper.post(buildUrl(`subscriptions/${subscriptionId}/cancel`), {
    injectToken: true,
  });
}

async function resumeSubscription(subscriptionId, { setup_intent_id, payment_method_id } = {}) {
  if (!subscriptionId) {
    throw new Error('subscription id is required');
  }
  return fetchWrapper.post(buildUrl(`subscriptions/${subscriptionId}/resume`), {
    injectToken: true,
    body: {
      setup_intent_id: setup_intent_id ?? null,
      payment_method_id: payment_method_id ?? null,
    },
  });
}

async function switchBusinessBilling(subscriptionId, { setup_intent_id, payment_method_id } = {}) {
  if (!subscriptionId) {
    throw new Error('subscription id is required');
  }
  return fetchWrapper.post(buildUrl(`subscriptions/${subscriptionId}/switch-business-billing`), {
    injectToken: true,
    body: {
      setup_intent_id: setup_intent_id ?? null,
      payment_method_id: payment_method_id ?? null,
    },
  });
}

const suartePlusService = {
  getConfig,
  calculateVat,
  subscribe,
  confirmPayment,
  cancelSubscription,
  resumeSubscription,
  switchBusinessBilling,
};

export default suartePlusService;
